<template>
  <ion-app>

    <router-view></router-view>
  </ion-app>
  <!--  <ion-app>-->
  <!--    <ion-content>-->
  <!--    </ion-content>-->
  <!--    <ion-router-outlet />-->
  <!--  </ion-app>-->
  <!--  <ion-router-outlet></ion-router-outlet>-->

</template>

<script>
import {
  IonApp
} from '@ionic/vue';

import {defineComponent} from 'vue';

export default defineComponent({
  name: 'Enrol',
  components: {
    IonApp,
  },
  data() {
    return {
      status: null,
    };
  },
  methods: {}
});
</script>
<style>

</style>
